import styled, { css } from 'styled-components'

import { FormFieldOrientationValues } from '../../../types/form'

export enum InputSize {
  Small = 'Small',
  Big = 'Big',
}

type InputStyleProps = {
  $isError?: boolean
  $isActive?: boolean
  $hasLabel?: boolean
  $isDisabled?: boolean
  $hasErrorMessage?: boolean
  $size?: InputSize
  $orientation?: FormFieldOrientationValues
  $type?: any
}

export const inputStyle = css<InputStyleProps>`
  ${({ theme }) => theme.textStyles.montserratSm};
  line-height: 1;
  width: 100%;
  height: 100%;
  border: 0;
  color: ${({ theme }) => theme.colors.dustyGray};
  background: transparent;
  transition: all 0.3s ease;

  ${({ $isActive }) =>
    $isActive === true &&
    css`
      color: ${({ theme }) => theme.colors.bluePrimary};
    `}

  // disabled
  ${({ $isDisabled }) =>
    $isDisabled === true &&
    css`
      pointer-events: none;
      color: ${({ theme }) => theme.colors.greyContour};
    `}

  &::placeholder {
    color: ${({ theme }) => theme.colors.dustyGray};
    ${({ theme }) => theme.textStyles.montserratSm};
  }

  // readonly
  &[readonly] {
    cursor: default;
  }

  &:focus {
    outline: none;
  }

  &[type='password']&:not(:placeholder) {
    letter-spacing: 3px;
  }
`

export const Input = styled.input<InputStyleProps>`
  ${inputStyle};
`
